import {
  DeleteOutlined,
  MoreOutlined,
  EyeOutlined,
  KeyOutlined,
  SyncOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { t } from "i18next";
import { CopyTextToClipboard } from "../../helpers/copy";
import { Button, Dropdown, Space, Switch } from "antd";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
import { hasPermission } from "../../utils";
// import { CheckTypeAdmin } from "../../helpers/checkPermission";

export const ColumnsUser = (
  tableParams,
  nameMerchang,
  dropdownPlacement,
  handleShowDetail,
  handleDelete,
  resProfileAdmin,
  history,
  handleResetTwoFactor,
  switchLoadindId,
) => [
    // id
    {
      title: "ID",
      key: "id",
      dataIndex: "id",
      render: (id, record, index) => {
        const userPermissions = Array.isArray(resProfileAdmin?.permissions)
          ? resProfileAdmin.permissions
          : [];

        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = record?.username === resProfileAdmin?.username || hasPermission(userPermissions, "details_user");

        return <>
          <span
            className={`hover text-center`}
            onClick={() => accessible ? handleShowDetail(record) : alert(t("You do not have permission to view other users' information."))}
            title="View details"
            style={{ cursor: "pointer", color: record?.username === resProfileAdmin?.username ? "#007bff" : "inherit" }}
          >
            <u>#{id}</u>
          </span>
        </>
      },
      sorter: false,
    },

    // Username
    {
      title: t("Username"),
      filterSearch: true,
      dataIndex: "username",
      key: "username",
      render: (username) => (
        <>
          {!username ? (
            <em style={{ color: "#888" }}>
              <small>No data</small>
            </em>
          ) : (
            <>
              <div className="row">
                <div
                  className="text-truncate"
                  style={{
                    marginRight: "8px",
                    color: "#3eacff",
                    cursor: "copy",
                  }}
                  onClick={() => CopyTextToClipboard(username)}
                >
                  <UserOutlined
                    style={{ marginRight: "5px", fontSize: "16px" }}
                  />
                  {username}
                </div>
              </div>
            </>
          )}
        </>
      ),
    },

    // type
    {
      title: t("Type admin"),
      filterSearch: false,
      dataIndex: "admin_type",
      key: "admin_type",
      render: (type) => {
        return (
          <span style={{ display: "inline-block" }} className="text-truncate">
            {type}
          </span>
        );
      },
    },

    // Roles
    {
      title: t("Role (system)"),
      filterSearch: false,
      dataIndex: "role",
      key: "role",
      render: (role, record) => {
        return (
          <span style={{ display: "inline-block" }} className="text-truncate">
            {role} ({record?.roleID})
          </span>
        );
      },
    },

    // Status
    {
      title: t("Status"),
      dataIndex: "admin_status",
      key: "admin_status",
      render: (status, record) => {
        const userPermissions = Array.isArray(resProfileAdmin?.permissions)
          ? resProfileAdmin.permissions
          : [];

        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = hasPermission(userPermissions, "on_off_user");

        return (
          <>
            <Switch
              size="small"
              checkedChildren={<>{t("enabled")}</>}
              unCheckedChildren={<>{t("disabled")}</>}
              checked={status === 1 ? true : false}
              loading={switchLoadindId === record?.id}
              onChange={(e) => accessible ? handleDelete(record, "status", e) : alert(t("You don't have permission to enabled/disabled user."))}
            />
          </>
        );
      },
    },

    // IP
    {
      title: t("IP"),
      filterSearch: true,
      dataIndex: "IP",
      key: "IP",
      render: (IP) => (
        <span
          style={{ maxWidth: "60px", color: "blueviolet" }}
          className="text-truncate"
        >
          {IP}
        </span>
      ),
    },

    // createdAt & Last login
    {
      title: (
        <>
          <span className="d-block" style={{ opacity: 0.8 }}>{t("createdAt")}</span>
          <span className="d-block">{t("Last login")}</span>
        </>
      ),
      filterSearch: true,
      dataIndex: "created_at",
      key: "created_at",
      render: (date, record) => {
        return (
          <>
            <span className="d-block" style={{ opacity: 0.8 }}>
              {FormatTimeAgo(date)}
            </span>
            <span className="d-block" style={{ fontWeight: "500" }}>
              {FormatTimeAgo(record.updated_at)}
            </span>
          </>
        );
      },
    },

    // Action
    {
      title: t("Action"),
      key: "action",
      render: (_, record) => {
        let isYou = record?.username === resProfileAdmin?.username ;
        const userPermissions = Array.isArray(resProfileAdmin?.permissions)
          ? resProfileAdmin.permissions
          : [];

        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible_details = isYou || hasPermission(userPermissions, "details_user");
        const accessible_del = hasPermission(userPermissions, "del_user");
        const accessible_reset2FA = hasPermission(userPermissions, "reset2FA_user");

        let menuItems = [];

        // details
        if (accessible_details) {
          menuItems.push({
            key: "Details",
            icon: <EyeOutlined />,
            label: <>{t("Details")}</>,
            onClick: () => handleShowDetail(record),
          },);
        }

        // Change Password
        if (isYou) {
          menuItems.push({
            key: "Profile",
            icon: <KeyOutlined />,
            style: { display: isYou ? "" : "none" },
            onClick: () => history.push("/profile"),
            label: <>{t("Change Password")}</>,
          },);
        }

        // reset2FA
        if (accessible_reset2FA) {
          menuItems.push({
            key: "ResetTwofactor",
            icon: <SyncOutlined />,
            onClick: () => handleResetTwoFactor(record),
            label: <>{t("Reset Two factor")}</>,
          },);
        }

        // Delete
        if (accessible_del) {
          menuItems.push({
            key: "Delete",
            icon: <DeleteOutlined />,
            label: <>{t("Delete")}</>,
            style: { color: "red" },
            onClick: () =>
              handleDelete(record, "delete", record?.admin_status),
          },);
        }

        return (
          //  PC
          <Space size="middle">


            {/* มือถือ */}
            <div className="md-show">
              {menuItems.length === 0 ? null :(<Dropdown
                arrow={true}
                trigger={["click"]}
                placement={dropdownPlacement || "bottomRight"}
                align="start"
                menu={{
                  items: menuItems,
                }}
              >
                <Button shape="circle">
                  <MoreOutlined
                    style={{ color: "#5A5A5A" }}
                    id="MoreOutlined"
                  />
                </Button>
              </Dropdown>)}
              
            </div>
          </Space>
        );
      },
    },
  ];
